import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { cancelTicketTransferService } from 'api/services/ticketTransfer/ticketTransferService'
import { getPurchaseOrderByIdRequestAction } from 'redux/Purchases/actions'
import { CustomerTickets } from 'redux/Purchases/types'
import { getTicketsInTransfer } from 'utils/ticketTransferUi'

type Props = {
  purchaseOrderId: string
  tickets: CustomerTickets[]
  ButtonComponent: React.ComponentType<
    React.ButtonHTMLAttributes<HTMLButtonElement>
  >
  ErrorComponent: React.ComponentType<{ children?: React.ReactNode }>
}

export const CancelTransferActions = ({
  purchaseOrderId,
  tickets,
  ButtonComponent,
  ErrorComponent
}: Props) => {
  const dispatch = useDispatch()
  const [cancellingTicketId, setCancellingTicketId] = useState<string | null>(
    null
  )
  const [cancelError, setCancelError] = useState('')
  const ticketsInTransfer = getTicketsInTransfer(tickets)

  if (ticketsInTransfer.length === 0) return null

  const handleCancelTransfer = async (customerTicketId: string) => {
    const confirmed = window.confirm(
      'Deseja cancelar esta transferência? O ingresso voltará para a sua conta e o destinatário será notificado.'
    )
    if (!confirmed) return

    setCancellingTicketId(customerTicketId)
    setCancelError('')
    try {
      await cancelTicketTransferService(customerTicketId)
      dispatch(getPurchaseOrderByIdRequestAction(purchaseOrderId))
    } catch (error: any) {
      setCancelError(
        error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          'Não foi possível cancelar a transferência.'
      )
    } finally {
      setCancellingTicketId(null)
    }
  }

  return (
    <>
      {ticketsInTransfer.map((ticket) => (
        <ButtonComponent
          key={ticket.id}
          type="button"
          disabled={cancellingTicketId === ticket.id}
          onClick={() => handleCancelTransfer(ticket.id)}>
          {cancellingTicketId === ticket.id
            ? 'Cancelando...'
            : ticketsInTransfer.length > 1
            ? `Cancelar transferência — ${ticket.ticket?.name || 'ingresso'}`
            : 'Cancelar transferência'}
        </ButtonComponent>
      ))}
      {cancelError ? <ErrorComponent>{cancelError}</ErrorComponent> : null}
    </>
  )
}
